'use strict';

module.exports = /* @ngInject */ function() {

	function preview(str, stringSize) {
		return str ? str.length <= stringSize ? str : str.substring(0, stringSize) + '...' : '';
	}

	return preview;
}
